import { mixinFreeColor } from './mixinVars';
export const defaultVars = {
    // 工作桌面导航背景颜色
    '--workbench-nav-bg-color': '#fff',
    // 工作桌面导航栏应用菜单扇叶颜色
    '--workbench-nav-allapps-color': '#fff',
    // 工作桌面导航栏搜索框默认背景色
    '--workbench-search-app-bg-color': '#fff',
    // 工作桌面导航栏搜索框默认边框颜色
    '--workbench-search-app-border-color': '#d7d7d7',
    // 导航栏图标颜色
    '--workbench-nav-icon-color': '#505766',
    // 应用菜单 标题 颜色
    '--workbench-allapps-title-color': '#2563eb',
    // 应用菜单 竖线颜色
    '--workbench-allapps-line-color': '#2563eb',
    // 个人中心文字hover颜色
    '--workbench-user-info-hover': '#eb5230',
    // 桌面配置顶部页签文字 底部横线 颜色
    '--workbench-desktop-setting-title-color': '#dd3730',
    // 桌面配置 当前分组页面背景色
    '--workbench-home-current-tab-bg-color': '#df4e2c',
    // 桌面分组文字颜色
    '--workbench-app-container-title-color': '#111',
    // 桌面配置 编辑态 当前分组页签文字颜色
    '--workbench-home-tab-editable-current-title-color': '#dd3730',
    // 面包屑文字颜色 
    '--workbench-nav-breadcrumb-color': '#767B83',
    // 面包屑当前节点文字颜色
    '--workbench-nav-breadcrumb-current-color': '#2B3441',
    // 面包屑中间箭头颜色
    '--workbench-nav-breadcrumb-color1': '#E0E1E4',
    // 工作桌面导航栏搜索框focus颜色
    '--workbench-search-app-focus-color': '#555',
    //搜索栏中主色调设为白色
    '--workbench-nav-select-color': '#fff',
    //搜索栏默认色边框颜色
    '--workbench-nav-border-color': '#D7D7D7',
    //搜索栏边框聚焦颜色
    '--workbench-nav-border-color-focus': '#0073E1',
    //搜索栏边框hover颜色
    '--workbench-nav-border-color-hover': '#505766',
    // 导航栏工作台选中激活颜色
    '--workbench-nav-active': mixinFreeColor('#fff', 0.95),
    //搜索栏竖线透明度
    '--workbench-nav-search-shuxian-opacity': 1,
    //搜索栏select框背景色
    '--workbench-nav-select-bg-color': 'white',
    //搜索栏select框文字hover时的颜色
    '--workbench-nav-select-text-color': 'rgba(240, 240, 240)',
    //搜索框联想面板的字体颜色
    '--workbench-nav-search-more-color': '#333333',
    //搜索框联想面板的分类标题颜色
    '--workbench-nav-search-title-color': '#111111',
    //搜索框联想面板标题背景颜色
    '--workbench-nav-title-bg-color': '#F8F8F8',
    //搜索栏下拉框图标颜色
    '--workbench-nav-select-drop-color': '#999999',
    //搜索栏下拉选中字体颜色
    '--workbench-nav-select-drop-text-color': 'rgba(233,240,250)',
    //搜索栏暂无数据搜索图标颜色
    '--workbench-nav-search-icon-sousuo1-color': '#d1d1d1',
    //搜索栏横线颜色
    '--workbench-nav-search-hr-color': '#F0F0F0',
    //内部页签标签栏背景色
    '--workbench-tab-wrapper-bg': '#F5F7F9',
    //内部页签标签栏背景下划线
    '--workbench-tab-bottom-color': 'rgba(238, 34, 51, 0.22)',
    //内部页签选中字体颜色
    '--workbench-tab-active-color': '#ee2233',
    // 面包屑首页下拉图标颜色
    '--workbench-breadcrumb-home-icon-c': '#111',
    // 面包屑首页下拉图标透明度
    '--workbench-breadcrumb-home-icon-o': 0.6,
    // 面包屑首页下拉图标边框透明度
    '--workbench-breadcrumb-home-icon-bo': 0.2,
    // 面包屑hover底色
    '--workbench-nav-breadcrumb-hover-bg-color': '#E0E1E4',
    // 内部页签右侧节点列表下拉背景色
    '--workbench-inside-tab-dropdown-bk': '#fff',
    // 内部页签右侧节点列表下拉item hover色
    '--workbench-inside-tab-dropdown-item-hover': '#EEF1F7',
    // tab右键文字颜色
    '--workbench-inside-tab-dropdown-text': '#333',
    '--workbench-nav-allapps-hover-color':'#f3f3f3',
    // 基于主色hsl格式，l值为93
    '--workbench-color-primary-l93': "rgba(238, 34, 51, 0.04)",
    '--workbench-color-primary-l95': "#EBEBEB",
};